/**
 * Generated by "@vuepress/internal-routes"
 */

import { injectComponentOption, ensureAsyncComponentsLoaded } from '@app/util'
import rootMixins from '@internal/root-mixins'
import GlobalLayout from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/lib/client/components/GlobalLayout.vue"

injectComponentOption(GlobalLayout, 'mixins', rootMixins)
export const routes = [
  {
    name: "v-9918d412",
    path: "/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9918d412").then(next)
    },
  },
  {
    path: "/index.html",
    redirect: "/"
  },
  {
    name: "v-05d4be8a",
    path: "/api/calendar.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-05d4be8a").then(next)
    },
  },
  {
    name: "v-9e116638",
    path: "/api/date-patterns.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9e116638").then(next)
    },
  },
  {
    name: "v-300724e1",
    path: "/api/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-300724e1").then(next)
    },
  },
  {
    path: "/api/index.html",
    redirect: "/api/"
  },
  {
    name: "v-1b062c26",
    path: "/api/day-object.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1b062c26").then(next)
    },
  },
  {
    name: "v-4a8d8624",
    path: "/api/attribute.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4a8d8624").then(next)
    },
  },
  {
    name: "v-32837fce",
    path: "/api/datepicker.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-32837fce").then(next)
    },
  },
  {
    name: "v-132b1162",
    path: "/api/defaults.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-132b1162").then(next)
    },
  },
  {
    name: "v-9ed191f8",
    path: "/api/page-object.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9ed191f8").then(next)
    },
  },
  {
    name: "v-7f66da8c",
    path: "/api/theme-styles.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7f66da8c").then(next)
    },
  },
  {
    name: "v-f5ffb980",
    path: "/changelog/v0.1.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-f5ffb980").then(next)
    },
  },
  {
    name: "v-fa92ea84",
    path: "/changelog/v0.2.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-fa92ea84").then(next)
    },
  },
  {
    name: "v-ff261b88",
    path: "/changelog/v0.3.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-ff261b88").then(next)
    },
  },
  {
    name: "v-7e2359ba",
    path: "/changelog/v0.4.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7e2359ba").then(next)
    },
  },
  {
    name: "v-799028b6",
    path: "/changelog/v0.6.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-799028b6").then(next)
    },
  },
  {
    name: "v-7bd9c138",
    path: "/changelog/v0.5.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7bd9c138").then(next)
    },
  },
  {
    name: "v-77469034",
    path: "/changelog/v0.7.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-77469034").then(next)
    },
  },
  {
    name: "v-74fcf7b2",
    path: "/changelog/v0.8.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-74fcf7b2").then(next)
    },
  },
  {
    name: "v-72b35f30",
    path: "/changelog/v0.9.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-72b35f30").then(next)
    },
  },
  {
    name: "v-5f046bb6",
    path: "/github/290.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5f046bb6").then(next)
    },
  },
  {
    name: "v-1d853af4",
    path: "/github/280.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1d853af4").then(next)
    },
  },
  {
    name: "v-5ac00b44",
    path: "/github/302.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5ac00b44").then(next)
    },
  },
  {
    name: "v-d1f16072",
    path: "/github/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("TestLayout", "v-d1f16072").then(next)
    },
  },
  {
    path: "/github/index.html",
    redirect: "/github/"
  },
  {
    name: "v-45396244",
    path: "/guide/theming-guide.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-45396244").then(next)
    },
  },
  {
    name: "v-682db816",
    path: "/guide/working-with-dates.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-682db816").then(next)
    },
  },
  {
    name: "v-f93619e6",
    path: "/mydemos/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-f93619e6").then(next)
    },
  },
  {
    path: "/mydemos/index.html",
    redirect: "/mydemos/"
  },
  {
    name: "v-67fa1cf2",
    path: "/showcase/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-67fa1cf2").then(next)
    },
  },
  {
    path: "/showcase/index.html",
    redirect: "/showcase/"
  },
  {
    name: "v-707303b8",
    path: "/showcase/github.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-707303b8").then(next)
    },
  },
  {
    name: "v-28b1145a",
    path: "/tests/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("TestLayout", "v-28b1145a").then(next)
    },
  },
  {
    path: "/tests/index.html",
    redirect: "/tests/"
  },
  {
    name: "v-1df78880",
    path: "/changelog/v1.0.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1df78880").then(next)
    },
  },
  {
    name: "v-f02f6994",
    path: "/guide/data.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-f02f6994").then(next)
    },
  },
  {
    name: "v-3efac25c",
    path: "/guide/datepicker.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-3efac25c").then(next)
    },
  },
  {
    name: "v-589704dc",
    path: "/guide/attributes.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-589704dc").then(next)
    },
  },
  {
    name: "v-242728dd",
    path: "/guide/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-242728dd").then(next)
    },
  },
  {
    path: "/guide/index.html",
    redirect: "/guide/"
  },
  {
    path: '*',
    component: GlobalLayout
  }
]